// extracted by mini-css-extract-plugin
export var typingIndicator = "_rs-0";